import Vue from 'vue'

/* <el-input
	clearable
	v-model="registerForm.mobile"
	placeholder="请输入手机号"
	@input="registerForm.mobile = verifyVal({ type: 'phone', val: $event, oldVal: registerForm.mobile }).value"
></el-input> */

// 手机号输入1-11位
const validateRules = {
	// 正则表达式：允许1位（必须是1），或者以1开头，总长度不超过11位
	phoneing: {
		reg: /^(1|1\d{0,10})$/,
		code: 'phoneing'
	},
	phone: {
		reg: /^1[3-9]\d{9}$/,
		code: 'phone'
	},
	// 正整数（不包括小数和0
	positiveInteger: {
		reg: /^[+]?[1-9]\d*$/,
		code: 'positiveInteger'
	},
}

export function verify(options = {}) {
	console.log('options: ',options);
	let {
		rules = [],
			// 要校验的值，必填
			val = '',
			// 旧的值，非必填
			oldVal = '',
			// 是否必填，非必填
			required = false
	} = options
	// 校验是否通过
	let result = {
		valid: false,
		value: '',
		code: '',
		message: ''
	}
	// 没有验证规则
	if (required && !val) {
		result.valid = false
		result.value = val
		result.code = 'required'
		return result
	} else if (!rules.length || !val) {
		result.valid = true
		result.value = val
		result.code = '200'
		return result
	} else {
		for (var i = 0; i < rules.length; i++) {
			let reg = '';
			let message = '';
			let code = '';
			// 字符串模式
			if (typeof rules[i] == 'string') {
				reg = validateRules[rules[i]].reg;
				code = rules[i];
			} else {
				// 对象模式,通常携带弹出错误提示
				reg = validateRules[rules[i].reg].reg;
				message = rules[i].message;
				code = rules[i].reg;
			}
			result.valid = reg.test(val)
			if (result.valid) {
				result.value = val
				// code没有值说明通过校验
				result.code = ''
			} else {
				result.value = oldVal
				// code有值，通过值判断哪种类型校验未通过
				result.code = code
				if (message) {
					Vue.prototype.$message({
						message: message,
						type: 'warning',
					});
				}
				break
			}
		}
		return result
	}
}
